import Network from './network';
const ATTRIBUTES_URL = '/Api/MotionAttributes';

export const GetMotionAttributes = async (params, cancelToken) => {
  let resp = await Network.Get(ATTRIBUTES_URL, params, cancelToken);
  return resp.data.items;
};
